import Vue from "vue";
import VueI18n from "vue-i18n";
import Meta from "vue-meta";
import BootstrapVue from "bootstrap-vue";
import VueMask from "v-mask";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import CKEditor from "@ckeditor/ckeditor5-vue";
import "@ckeditor/ckeditor5-build-classic/build/translations/ru";

import VMdDateRangePicker from "v-md-date-range-picker";

import router from "./router";
import store from "./store";
import user from "./user";
import "./registerServiceWorker";

Vue.use(VueI18n);
Vue.use(Meta);
Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(user);
Vue.use(CKEditor);
Vue.use(VMdDateRangePicker);

const locales = {
  uk: "",
  ru: ""
};

const messages = {
  uk: {},
  ru: {}
};

const i18n = new VueI18n({
  locale: "uk",
  fallbackLocale: "ru",
  messages
});

library.add(fas, far);

Vue.component("font-awesome-icon", FontAwesomeIcon);

function getLocale() {
  let locale = Object.keys(locales)[0];
  const local = window.localStorage.getItem("locale");
  if (local !== null) {
    locale = local;
  }
  return locale;
}

router.beforeEach((to, from, next) => {
  const locale = getLocale();
  if (to.params.locale !== undefined) {
    if (locales[to.params.locale] !== undefined) {
      if (to.path.slice(-1) !== "/") {
        if (window.localStorage.getItem("locale") !== to.params.locale) {
          window.localStorage.setItem("locale", to.params.locale);
        }
        i18n.locale = to.params.locale;
        next();
      } else {
        store.state.referer =
          location.protocol +
          "//" +
          location.host +
          to.path.substr(0, to.path.length - 1);
        next("/" + to.params.locale + "/301");
      }
    } else {
      next("/" + locale + "/404");
    }
  } else {
    next("/" + locale);
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(router.app.$route.meta.layout)
}).$mount("#app");
